<template>
  <Layout1 title="Reset your <cloudName> password">

    <template slot="form">
      <form @submit.prevent="sendVerificationLink()">
         <div>
          <label class="fn14 col__new_darkgrey ln_ht20 fw400">Enter the email ID associated with your {{cloudName}} account</label>
          <div class="form-floating mt10">
            <input
              type="email"
              id="email"
              name="email"
              v-model="form.email"
              placeholder="Email"
              class="form-control fn14"
              v-validate="'required|email'"
            />
            <label for="email">Email</label>
            <small class="col_error" v-show="errors.has('email')">{{ errors.first('email') }}</small>
             <vue-recaptcha class="mt-3"
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    @expired="onCaptchaExpired"
                    :sitekey="siteKey">
                  </vue-recaptcha>
          </div>
         </div>
          <div class="mb20 mt20">
            <input :disabled="!(fields.email && fields.email.valid && form['g-recaptcha-response'])"  type="submit" class="btn btn-apiculus-primary mr-2" value="SEND PASSWORD RESET INSTRUCTIONS" />
            <router-link class="col_primary" to="/">Back to login</router-link>
          </div>
      </form>
    </template>
  </Layout1>
</template>

<script>
import Layout1 from './Layout1.vue'
import VueRecaptcha from 'vue-recaptcha'
import helpers from '../../services/toast-service'

export default {
  name: 'ForgotPassword',
  mixins: [helpers],
  data () {
    return {
      form: {
      'g-recaptcha-response': '',
      email: ''
    },
    color: '',
    full_screen: '',
    message: '',
    navLogo: '',
    bannerAsset: '',
    bannerElement: false,
    cloudName: ''
    }
  },
  computed: {
    siteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  components: {
    Layout1,
    VueRecaptcha
  },
  methods: {
    sendVerificationLink () {
      this.$store.dispatch('ACTION_SEND_VERIFICATION_LINK', { ...this.form }).then(res => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'Something went wrong, Please try again later.', 'error')
          this.form['g-recaptcha-response'] = ''
          this.$refs.recaptcha.reset()
        } else {
          this.$store.state.forEmailVerification = true
          this.$store.state.forAdminApproval = false
          this.$router.push({ name: 'resendLink', query: {email: this.form.email} })
          // this.$router.push('rese', { name: 'Someone' })
        }
      })
    },
    onCaptchaVerified (res) {
      this.form['g-recaptcha-response'] = res
    },
    onCaptchaExpired (res) {
      this.form['g-recaptcha-response'] = ''
      this.$refs.recaptcha.reset()
    }
  },
  created () {
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'banner.png' }).then(res => {
      let downloadFiles
      if (res && typeof res === 'string') {
        downloadFiles = 'data:image/png;base64,' + res
        this.bannerAsset = downloadFiles
        this.bannerShow = true
        let urlString = ''
        setTimeout(() => {
          urlString = document.getElementById('check')
          urlString.classList.add('bannerElement')
          urlString.style.backgroundImage = 'url(' + this.bannerAsset + ')'
        }, 0)
      } else {
        this.bannerAsset = ''
        this.bannerShow = false
      }
    })
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'logo-main.png' }).then(res => {
      if (res) {
        let downloadFile = 'data:image/png;base64,' + res
        this.navLogo = downloadFile
      } else {
        this.navLogo = ''
      }
    })
    this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
      if (res) {
        this.cloudName = res.name
      }
    })
  }
}
</script>

<style scoped>

</style>
